import { gql, TypedDocumentNode } from "@apollo/client";

import { QueryMetricsRangeArgs, SpaceliftMetrics } from "types/generated";

type GetChangeFailureRateAverageData = {
  metricsRange: Pick<SpaceliftMetrics, "changeFailureRateValue">;
};

export const GET_CHANGE_FAILURE_RATE_AVERAGE: TypedDocumentNode<
  GetChangeFailureRateAverageData,
  QueryMetricsRangeArgs
> = gql`
  query GetChangeFailureRateAverage($input: MetricsInput) {
    metricsRange(input: $input) {
      changeFailureRateValue {
        value
      }
    }
  }
`;
